import {
  Button,
  FormControlLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import "./styles.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { sxButton, sxError, sxInput, sxLabel } from "./sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FirstStepProps } from "../../../../interfaces/props/Financeiro/Reembolso/FirstStepProps";
import {
  ListaDependentes,
} from "../../../../interfaces/entities/Reembolso/Dependentes";
import { RefundRequestContactValidation } from "../../../../interfaces/validation/Reembolso/RefundRequestContactValidation";
import { getDadosBeneficiarioProdExecutivo } from "../../../../services/Financeiro/ReembolsoService";
import LoadingApp from "../../../../components/LoadingApp";
import { cellphoneMask } from "../../../../utils/PhoneRegex";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";

function StepSelecaoBeneficiario(props: FirstStepProps) {
  const { beneficiarySelected, cel, email } = props;
  const [beneficiary, setBeneficiary] = useState<ListaDependentes | null>(null);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [beneficiaryList, setBeneficiaryList] = useState<ListaDependentes[]>(
    []
  );
  const formik = useFormik({
    initialValues: { cel, email },
    validationSchema: RefundRequestContactValidation,
    onSubmit: (values) => {
      if (beneficiary) {
        props.handleFirstStep(values.cel, values.email, beneficiary);
      }
    },
    validateOnChange: false,
  });
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  useEffect(() => {
    const getBeneficiaryList = async () => {
      setShowLoading(true);
      const result = await getDadosBeneficiarioProdExecutivo();
      if (result !== null) {
        setBeneficiaryList(result.lstDependentes);

        if (!beneficiarySelected?.idUsrContrDependente) {
          const selectedBeneficiary = result.lstDependentes.find(item => item.isChecked);
          if (selectedBeneficiary) {
            setBeneficiary(selectedBeneficiary);
          }
        } else {
          setBeneficiary(beneficiarySelected);
        }

        setShowLoading(false);
      }
    };

    formik.setValues({ cel: cellphoneMask(props.cel), email: props.email });
    getBeneficiaryList();
    props.handleRegrasReembolso();
  }, [cel, email]);

  const handleBeneficiary = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = event.target.value;
    const selectedBeneficiary =
      beneficiaryList.find(
        (item) => item.idUsrContrDependente === selectedId
      ) || null;
    setBeneficiary(selectedBeneficiary);
  };

  const goBack = () => {
    navigate("/financeiro/reembolso/");
  };


  return (
    <div className="refund-request-first-step-content">
      <LoadingApp showLoading={showLoading} />
      <h2
        className="first-step-title"
        style={accessibility.textStyleAccessibility}
      >
        Beneficiário atendido
      </h2>
      {
        beneficiaryList?.length > 0 &&
        <div className="first-step-radio-holder">
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={beneficiary?.idUsrContrDependente || beneficiarySelected?.idUsrContrDependente}
            onChange={handleBeneficiary}
            style={accessibility.textTitleStyleAccessibility}
          >
            {beneficiaryList.map((item, index) => {
              return (
                <FormControlLabel
                  key={index}
                  value={item.idUsrContrDependente}
                  control={
                    <Radio
                      style={accessibility.contrastColorAccessibility}
                      size="small"
                    />
                  }
                  label={item.nomeDependente}
                />
              );
            })}
          </RadioGroup>
        </div>}
      <div className="first-step-contact">
        <h1
          style={accessibility.textStyleAccessibility}
          className="first-step-title"
        >
          Contato
        </h1>
        <form onSubmit={formik.handleSubmit}>
          <div className="first-step-contact-info">
            <Typography
              style={accessibility.textStyleAccessibility}
              sx={sxLabel}
            >
              Celular
            </Typography>
            <label htmlFor="celInput" aria-label="celular" />
            <OutlinedInput
              fullWidth
              id="celInput"
              type={"tel"}
              value={formik.values.cel}
              onChange={(e) => formik.setFieldValue('cel', cellphoneMask(e.target.value))}
              name="cel"
              error={!!formik.errors.cel}
              maxRows={1}
              inputProps={{ maxLength: 15 }}
              sx={sxInput}
              style={accessibility.textStyleAccessibility}
            />
            {formik.errors.cel && (
              <Typography tabIndex={0} sx={sxError}>
                {formik.errors.cel}
              </Typography>
            )}
          </div>
          <div className="first-step-contact-info">
            <Typography
              sx={sxLabel}
              style={accessibility.textStyleAccessibility}
            >
              E-mail
            </Typography>
            <label htmlFor="emailInput" aria-label="email" />
            <OutlinedInput
              fullWidth
              id="emailInput"
              type={"email"}
              value={formik.values.email}
              onChange={formik.handleChange}
              name="email"
              error={!!formik.errors.email}
              maxRows={1}
              inputProps={{ maxLength: 100 }}
              sx={sxInput}
              style={accessibility.textStyleAccessibility}
            />
            {formik.errors.email && (
              <Typography tabIndex={0} sx={sxError}>
                {formik.errors.email}
              </Typography>
            )}
          </div>
          <div className="first-step-contact-buttons">
            <div className="first-step-contact-button">
              <Button
                variant="contained"
                type="submit"
                sx={sxButton}
                style={accessibility.buttonStyleAccessibility}
                disabled={false}
                fullWidth
              >
                <span style={accessibility.buttonTextStyleAccessibility}>
                  Confirmar
                </span>
              </Button>
            </div>
          </div>
        </form>
        <button
          style={accessibility.textStyleAccessibility}
          className="back-button"
          onClick={goBack}
          aria-label="Voltar para informar protocolo"
        >
          <FontAwesomeIcon
            style={accessibility.textStyleAccessibility}
            icon={faChevronLeft}
          />
          &nbsp;&nbsp;<u>Voltar</u>
        </button>
      </div>
    </div >
  );
}

export default StepSelecaoBeneficiario;
